import { render, staticRenderFns } from "./dealer-name-marquee.vue?vue&type=template&id=c6d77022&scoped=true&"
import script from "./dealer-name-marquee.vue?vue&type=script&lang=js&"
export * from "./dealer-name-marquee.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=c6d77022&scoped=true&lang=css&"
import style1 from "./dealer-name-marquee.vue?vue&type=style&index=1&id=c6d77022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d77022",
  null
  
)

export default component.exports